<div [ngClass]="LanguageClass" i18n-class="@@LanguageClass">
    <div [ngClass]="DirectionClass" i18n-class="@@DirectionClass">

        <!-- ======================= Page Header ========================== -->
        <div class="wr-page-title">
            <div class="col-lg-12 zero-padding">
                <div class="card remove-card-bg">

                        <!-- Page Title -->
                        <div class="page-title">
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-9 col-md-8 mobile-m-b-10 mobile-header-style">
                                        <div class="layout-container">
                                            <div class="layout-col">
                                                <img src="assets/img/logo-amex.png" alt="Logo AMEX" i18n-alt="@@AmexLogoTxt"
                                                     class="m-r-20" />
                                            </div>
                                            <div class="layout-col title-mobile-large">
                                                <div>
                                                <span class="app-title-long" i18n="@@AppTitle">
                                                    Credit Card Payment Calculator
                                                </span>
                                                <span class="app-title-short" i18n="@@AppTitleShort">
                                                    Credit Card Payment Calculator
                                                </span>
                                            </div>
                                                <div>
                                                  <span class="text-modified-date" i18n="@@LastUpdate">Last update:</span>
                                                  <span class="text-modified-date">{{currentDate | date:'dd-MM-yyyy'}}</span>
                                                </div>
                                            </div>
                                            <div class="layout-col title-mobile-small" >
                                                <div i18n="@@AppTitleMobile3">Credit Card Payment Calculator</div>
                                                <div>
                                                  <span class="text-modified-date" i18n="@@LastUpdate">Last update:</span>
                                                  <span class="text-modified-date">{{currentDate | date:'dd-MM-yyyy'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-4 mobile-m-b-10">
                                        <table cellpadding="0" cellspacing="0" border="0" class="full-width m-t-5">
                                            <tr>
                                                <td class="header-td-01">&nbsp;
                                                    
                                                </td>
                                                <td class="header-td-03">&nbsp;
                                                    
                                                </td>

                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /Page Title -->

                </div>
            </div>
        </div>
            <!-- ======================= /Page Header ========================== -->
            <!-- ======================= Page Body ========================== -->
            <router-outlet></router-outlet>
                        <!-- ======================= /Page Body ========================== -->
            <!-- ========== Page Footer ================= -->
            <div class="page-footer">
                <div class="container">
                    &copy;
                    {{fullYear}} <ng-container i18n="@@CopyrightStatement">CopyrightStatement</ng-container>
                </div>
            </div>
            <!-- ========== /Page Footer ================= -->

        </div>
    </div>
